<template>

  <div id="" >
    <van-col span="24" class="no_data_status" v-if="is_no_data">
      <van-icon name="clock-o" /> &nbsp;&nbsp;&nbsp;{{ $t('onLoad.No_record') }}
    </van-col>
    <van-col span="24" class="invite_share_user" v-else>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :head-height="100">
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          :offset="10"
          finished-text="$t('onLoad.finished_text')"
        >
          <div class="list-item">
            <van-cell v-for="(l) in list" :key="l.id">
                <van-col span="6" class="invite_share_user_img">
                  <img :src="l.avatar"/>
                </van-col>
                <van-col span="12" class="invite_share_user_title">
                  <van-col span="24" class="invite_share_user_name">{{ l.user_nickname }}</van-col>
                  <van-col span="24" class="invite_share_user_id">{{$t('share.account_number_id')}} ：{{ l.id }}</van-col>
                </van-col>
                <van-col span="6" class="invite_share_user_coin">
                    + {{ l.income_total }}
                </van-col>
            </van-cell>
          </div>
        </van-list>
      </van-pull-refresh>
    </van-col>
  </div>
</template>
<script>
  //请求接口组件
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  import { Col, Row, PullRefresh, List, Cell } from 'vant'
  export default {
    name: 'share',
    data:function() {
      return {
        list:[],
        page: 1,
        // 是否处于加载状态
        loading: false,
        // 是否已加载完所有数据
        finished: false,
        // 是否处于下拉刷新状态
        isLoading: false,
        is_no_data: false
      }
    },
    components: {
      [Col.name]: Col,
      [Row.name]: Row,
      [PullRefresh.name]: PullRefresh,
      [List.name]: List,
      [Cell.name]: Cell
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.invited_share')
    },
    methods: {
      onLoad () {
        // 上拉加载
        this.convert()
      },
      onRefresh () {
        // 下拉刷新
        this.finished = false
        this.isLoading = false
        this.list = []
        this.page = 1
        this.onLoad()
      },
      convert: function() {
        var uid = this.$route.query.uid;
        var token = this.$route.query.token;
        axios.get(this.baseUrlApi+"mapi/public/index.php/api/invited_share_api/user_vue",{ params:{ uid:uid,token:token }}).then(res =>{
          console.log(res.data)
          this.loading = true
          this.finished = true
          if (res.data.code === 1) {
            if (res.data.data.length > 0) {
              if (this.page === 1) {
                this.list = []
              }
              for (var i = 0; i < res.data.data.length; i++) {
                this.list.push(res.data.data[i])
              }
              this.loading = false
              this.page = this.page + 1
            } else {
              if (this.page === 1) {
                this.is_no_data = true
              }
            }
          } else {
            Toast(res.data.msg)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/invited_share_user.vue